import star from '../../assets/images/star.png'


import styled from 'styled-components'

const CardNFTWrapper = styled.div`
min-height:420px;
min-width:205px;
width:240px;
margin-right:30px;

background: radial-gradient(145.1% 102.55% at 0% 50%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
backdrop-filter: blur(38.2676px);
padding:13px 24px 24px 24px;
margin-bottom:70px;

border-width: 2px;
border-style: solid;
border-image: linear-gradient(to right, gray 0%, white 50%) 1;

@media(max-width: 800px) {
    min-height:420px;
    min-width:315px;
  }
`

const CardTitleContainer = styled.div`
    display:flex;
    align-items:center;
    flex-direction:row;
    position:relative;
`

const ImageNFT = styled.img`
margin-top:16px;
margin-bottom:25px;
width:100%;
height:100%;
`

const ImgOwner = styled.img`
height:40px;
width:40px;
`
const CardInfo = styled.div`
display:flex;
flex-direction:row;
justify-content:space-between;
`

const CardInfoLeft = styled.div`
display:flex;
flex-direction:column;


p:first-child {
   
font-family: Poppins;
font-style: normal;
font-weight: 500;
font-size: 15.3095px;
line-height: 26px;
/* or 170% */


color: #A7A7A7;
}

p {
    margin:0;
    padding:0;
}
p:last-child {
    
    font-family: Poppins;
    font-style: normal;
    font-weight: bold;
    font-size: 21.6134px;
    line-height: 26px;
    /* or 120% */
    
    
    color: #FFFFFF;
    }
`
const CardInfoRight = styled.div`
display:flex;
flex-direction:column;
text-align:right;

 p:first-child {
   
font-family: Poppins;
font-style: normal;
font-weight: 500;
font-size: 15.3095px;
line-height: 26px;
/* or 170% */


color: #A7A7A7;
}
p {
    margin:0;
    padding:0;
}

p:last-child {
    
font-family: Poppins;
font-style: normal;
font-weight: bold;
font-size: 21.6134px;
line-height: 26px;
/* or 120% */


color: #FFFFFF;
}
`





const Card = ({ item }) => {
    return (
        <CardNFTWrapper>
            <CardTitleContainer>
                <ImgOwner src={item.img} />
                <p style={{ marginLeft: 10 }}>{item.owner}</p>
                <div style={{ position: 'absolute', right: 0, display: 'flex', alignItems: 'center' }}>
                    <img src={star} style={{ marginRight: 15 }} />
                    213
                </div>
            </CardTitleContainer>
            <div>
                <ImageNFT src={item.nftImage} />
            </div>

            <CardInfo>
                <CardInfoLeft>
                    <p>Current bid</p>
                    <p>0.54 ETH</p>
                </CardInfoLeft>

                <CardInfoRight>
                    <p>Ending in</p>
                    <p>12h 55m 2s</p>
                </CardInfoRight>

            </CardInfo>
        </CardNFTWrapper>
    )
};


export default Card;